<div class="processing-wrapper">
  <div class="flex justify-between">
    <p class="processing-label">
      {{ label | translate }}
    </p>
    <p class="processing-time">
      {{
        elapsedDisplay > durationDisplay ? durationDisplay : elapsedDisplay
      }}
      / {{ durationDisplay }}
    </p>
  </div>

  <div class="processing-visual">
    <div class="bg" [ngStyle]="{ 'width.%': percent }">
      <div
        class="water"
        [ngStyle]="{
          'animation-duration.ms': 5000,
          'animation-iteration-count': 'infinite',
        }"
      ></div>
    </div>
  </div>
</div>
